import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from 'components/shared/header/component';
import FacilitatorSwitchView from 'components/manager/facilitator/switch-view/component';
import { UserRouter } from 'components/routers/UserRouter';
import { websocketConnectAction } from '../../../../redux/actions/shared.actions';
import { USER_RANK_ADMIN, USER_RANK_FACILITATOR } from 'components/permissions/types';
export default function ViewWrapper() {
    var token = useSelector(function (state) { return state.playerAuthorization.token; });
    var rank = useSelector(function (state) { return state.userAuthorization.userSession.rank; });
    var dispatch = useDispatch();
    var websocketConnection = function (t) { return dispatch(websocketConnectAction(t)); };
    var isManagerRank = [USER_RANK_ADMIN, USER_RANK_FACILITATOR].includes(rank);
    return (React.createElement("div", { className: "wrapper" },
        React.createElement("div", { className: "container-fluid" },
            React.createElement(Header, null),
            React.createElement(UserRouter, { rank: rank }),
            isManagerRank ? React.createElement(FacilitatorSwitchView, null) : null)));
}
